/**
 * Defines the common keys for CMCD (Common Media Client Data) version 2.
 *
 *
 * @beta
 */
export const CMCD_COMMON_KEYS = [
	'ab',
	'bg',
	'bl',
	'br',
	'bs',
	'bsd',
	'cdn',
	'cid',
	'cs',
	'df',
	'ec',
	'lab',
	'lb',
	'ltc',
	'msd',
	'mtp',
	'pb',
	'pr',
	'pt',
	'sf',
	'sid',
	'sn',
	'st',
	'sta',
	'tab',
	'tb',
	'tbl',
	'tpb',
	'ts',
	'v',
] as const
